export const EXTEND_START_DATE = 'EXTEND_START_DATE';
export const EXTEND_END_DATE = 'EXTEND_END_DATE';

export function extendStartDate(id, newStartDate) {
  return {
    type: EXTEND_START_DATE,
    payload: {
      id,
      newStartDate,
    },
  };
}

export function extendEndDate(id, newEndDate) {
  return {
    type: EXTEND_END_DATE,
    payload: {
      id,
      newEndDate,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/debug.js